export default __webpack_public_path__ + "static/media/AnnualFee.71f225d5.svg";